import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {RequestMethod, Response} from "@angular/http";
import {CommentView} from "../../+tickets/ticket.service";
import {RequestConfig} from "../../shared/rest/rest.request";
import {CustomHttp} from "../http/custom.http";
import { Observable } from "rxjs";
import { CommentErrorDetected } from "./comments.interface";
import { Comments } from "app/+tickets/folder/modal-ventas/ventas.service";


@Injectable()
export class CommentService {
    private GET_TICKET_COMMENTS = new RequestConfig("COMT001", "application/json", true, RequestMethod.Get, "/tickets/{ticketId}/comments?includeB64File=true");
    private ADD_TICKET_COMMENT = new RequestConfig("COMT001", "application/json", true, RequestMethod.Post, "/tickets/{ticketId}/comments");
    private URL_ATTACHMENT_CODE = new RequestConfig("COMT003", "application/x-www-form-urlencoded", true, RequestMethod.Get, "/tickets/comments/attachments/{attachmentId}", true);
    private ADD_TASK_COMMENT = new RequestConfig("COMT004", "application/json", true, RequestMethod.Post, "/tickets/{ticketId}/tasks/{taskId}/comments");
    private GET_TASK_COMMENTS = new RequestConfig("COMT005", "application/json", true, RequestMethod.Get, "/tickets/{ticketId}/tasks/{taskId}/comments?includeB64File=true");
    private ADD_REMOTE_SALE_TICKET_COMMENT = new RequestConfig("COMT006", "application/json", true, RequestMethod.Post, "/tickets/{ticketId}/comments/ventaRemota");
   private GET_IMAGE_VENTAWEB = new RequestConfig("COMT001", "application/json", true, RequestMethod.Get, "/tickets/web-attachment/?idGrupoWeb={groupVentaWeb}");

    public comments: Subject<any> = new Subject<any>();    
    public allowGetComments:boolean = true;

    constructor(private http: CustomHttp) {
        this.comments = new Subject();
    }

    getTicketComments(ticketId: number): void {
        this.http.sendRequest(this.GET_TICKET_COMMENTS, {}, ticketId)
            .map((res): Response => res.json())
            .do(data => this.comments.next(data))
            .catch(error => {
                return this.http.handleError(error);
            }).subscribe(name, error => this.comments.error(error));
    }

    getTicketCommentsReturn(ticketId: number) {
        this.allowGetComments = false;
        return this.http.sendRequest(this.GET_TICKET_COMMENTS, {}, ticketId)
        .map(res => {
            this.allowGetComments = true;
            return res.json() as Comment[];
        })
        .catch(error => {
            this.allowGetComments = true;
            return this.http.handleError(error);
        });
    }
    getGroupImageReturn(groupVentaWeb: String) {
        this.allowGetComments = false;
        return this.http.sendRequest(this.GET_IMAGE_VENTAWEB, {}, groupVentaWeb)
        .map(res => {
            this.allowGetComments = true;
            return res.json() as imageVentaWEB[];
        })
        .catch(error => {
            this.allowGetComments = true;
            return this.http.handleError(error);
        });
    }

    addTicketComment(ticketId: number, comment: CommentView | CommentErrorDetected) {
        this.allowGetComments = false;
        return this.http.sendRequest(this.ADD_TICKET_COMMENT, comment, ticketId)
            .catch(error => {
                this.allowGetComments = true;
                return this.http.handleError(error);
            })
            .map(()=>{ this.allowGetComments = true;})
    }

    addTaskComment(taskId: number, ticketId: number, comment: CommentView | CommentErrorDetected) {
        return this.http.sendRequest(this.ADD_TASK_COMMENT, comment, ticketId, taskId)
            .catch(error => this.http.handleError(error));
    }

    getTaskComments(ticketId: number, taskId: number) {
        this.http.sendRequest(this.GET_TASK_COMMENTS, {}, ticketId, taskId)
            .map((res): Response => res.json())
            .do(data => this.comments.next(data))
            .catch(error => this.http.handleError(error)).subscribe(null, error => this.http.handleError(error));
    }

    getAttachment(id: any, type: string): any {
        return this.http.sendRequest(this.URL_ATTACHMENT_CODE, {}, id)
            .map(res => res.blob())
            .catch(error => this.http.handleError(error));
    }

    /**
     * Detecta el tipo de contenido a partir del base64
     * @param base64 El contenido base64
     * @returns El tipo MIME del contenido
     */
    detectImageType(base64: string): string {
        if (!base64) return 'application/octet-stream';
        if (base64.startsWith('iVBORw0KGgo')) return 'image/png';
        if (base64.startsWith('/9j/')) return 'image/jpeg';
        if (base64.startsWith('R0lGOD')) return 'image/gif';
        if (base64.startsWith('JVBERi0')) return 'application/pdf';
        return 'application/octet-stream';
    }

    /**
     * Obtiene el contenido base64 de una imagen desde Alfresco.
     * @param fileSystemPathAlfresco La URL del archivo en Alfresco
     * @returns Observable<string> El contenido base64
     */
    getAttachmentAsBlobUrl(fileSystemPathAlfresco: string): Observable<string> {
        return new Observable<string>((observer) => {
            
            fetch(fileSystemPathAlfresco, {
                method: 'GET',
                headers: {
                    'X-API-KEY': 'Y1UxUFNEKFNvZVJ4LDk2',
                }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                // La respuesta es { base64Content: "...", contentType: "..." }
                if (data && data.base64Content) {
                    // Usar el contentType de la respuesta o detectar desde el base64
                    const contentType = data.contentType || this.detectImageType(data.base64Content);
                    observer.next(data.base64Content);
                    observer.complete();
                } else {
                    observer.error(new Error('No se encontró base64Content en la respuesta'));
                }
            })
            .catch(error => {
                console.error('Error al obtener imagen de Alfresco:', error);
                observer.error(error);
            });
        });
    }

    /**
     * Alias para getAttachmentAsBlobUrl - mantiene compatibilidad con código existente.
     * @param fileSystemPathAlfresco La URL del archivo en Alfresco
     * @returns Observable<string> El contenido base64
     */
    getAlfrescoFileBase64(fileSystemPathAlfresco: string): Observable<string> {
        return this.getAttachmentAsBlobUrl(fileSystemPathAlfresco);
    }

    getTaskCommentsReturn(ticketId: number, taskId: number) {
        this.allowGetComments = false;
        return this.http.sendRequest(this.GET_TASK_COMMENTS, {}, ticketId, taskId)
        .map(res => {
            this.allowGetComments = true;
            return res.json() as Comment[];
        })
        .catch(error => {
            this.allowGetComments = true;
            return this.http.handleError(error);
        });
    }

    addRemoteSaleTicketComment(ticketId: number, comment: Comments) {
        this.allowGetComments = false;
        return this.http.sendRequest(this.ADD_REMOTE_SALE_TICKET_COMMENT, comment, ticketId)
            .catch(error => {
                return this.http.handleError(error);
            })
    }
}

export class Comment {
    idComment: number;
    commentDate: number;
    comment: string;
    activityType: string;
    commentVisibility: string;
    commentName: string;
    commentUsername: string;
    attachments: Attachment[];
    deviceId?: any;
    idUser?: any;
    idOwner?: any;
    solicitudVenta?: any;
    idTask?: any;
    idTicket: number;
  }
  export class imageVentaWEB {
    idWebAttachment: number;
    fileName: string;
    code: number;
    fileSystemPath: string;
    contentType: string;
    uploadDate?: any;
    idGrupoWeb: string;
    idImageLoss?: any; 
    name?: string;

  }
  
  
  interface Attachment {
    idAttachment: number;
    fileName: string;
    fileB64Content: string;
    contentType: string;
    size: number;
    uploadDate: number;
    fileSystemPath: string;
    code?: any;
  }